// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.btn {
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  font-family: var(--font-body);
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-primary {
  background-color: var(--dark);
  color: var(--bg);
}

.btn-primary:hover {
  background-color: #1a1118;
}

.btn-secondary {
  background-color: var(--gold);
  color: white;
}

.btn-secondary:hover {
  background-color: #a89452;
}

.btn-outline {
  background-color: transparent;
  border: 2px solid var(--dark);
  color: var(--dark);
}

.btn-outline:hover {
  background-color: var(--dark);
  color: var(--bg);
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.card {
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  box-shadow: 0 2px 8px var(--shadow);
  padding: 20px;
}

.error-message {
  background-color: #fee;
  color: var(--error);
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.success-message {
  background-color: #efe;
  color: var(--success);
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 16px;
}

.loading {
  text-align: center;
  padding: 40px;
  color: var(--text-light);
  font-family: var(--font-body);
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--text-light);
}

.empty-state h2 {
  margin-bottom: 16px;
  color: var(--dark);
}

.empty-state p {
  margin-bottom: 24px;
}

@media (max-width: 768px) {
  .btn {
    padding: 10px 20px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":[".app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.main-content {\n  flex: 1;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.btn {\n  padding: 12px 24px;\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: var(--font-body);\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.btn-primary {\n  background-color: var(--dark);\n  color: var(--bg);\n}\n\n.btn-primary:hover {\n  background-color: #1a1118;\n}\n\n.btn-secondary {\n  background-color: var(--gold);\n  color: white;\n}\n\n.btn-secondary:hover {\n  background-color: #a89452;\n}\n\n.btn-outline {\n  background-color: transparent;\n  border: 2px solid var(--dark);\n  color: var(--dark);\n}\n\n.btn-outline:hover {\n  background-color: var(--dark);\n  color: var(--bg);\n}\n\n.btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.card {\n  background: rgba(255, 255, 255, 0.5);\n  border-radius: 12px;\n  box-shadow: 0 2px 8px var(--shadow);\n  padding: 20px;\n}\n\n.error-message {\n  background-color: #fee;\n  color: var(--error);\n  padding: 12px;\n  border-radius: 4px;\n  margin-bottom: 16px;\n}\n\n.success-message {\n  background-color: #efe;\n  color: var(--success);\n  padding: 12px;\n  border-radius: 4px;\n  margin-bottom: 16px;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  color: var(--text-light);\n  font-family: var(--font-body);\n}\n\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--text-light);\n}\n\n.empty-state h2 {\n  margin-bottom: 16px;\n  color: var(--dark);\n}\n\n.empty-state p {\n  margin-bottom: 24px;\n}\n\n@media (max-width: 768px) {\n  .btn {\n    padding: 10px 20px;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
